import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';

import {PoDynamicFormField, PoLookupColumn, PoLookupFilter, PoLookupFilteredItemsParams} from '@po-ui/ng-components';
import {environment} from 'src/environments/environment';
import { Fornecedor, FornecedorDtoList } from '../interface/fornecedor';
import { UtilService } from './util';

@Injectable({
  providedIn: 'root'
})
export class FornecedorService {

  url = `${environment.urlApiProtheus}/wsrfornecedor`;

  constructor(
    private httpClient: HttpClient,
    private utilService: UtilService,
  ){}

  getFornecedorLista(filtro: {}): Observable<FornecedorDtoList> {
    const httpOptions = this.utilService.filtrosHttpOptions(filtro);
    return this.httpClient.get<FornecedorDtoList>(`${this.url}`,httpOptions);
  }


  postFornecedor(fornecedor: Fornecedor) {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.post(`${this.url}`, fornecedor, httpOptions);
  }

  getFornecedor(CCODIGOLOJA: string, CMODELO: 'C' | '' = ''): Observable<Fornecedor> {
    const httpOptions = this.utilService.filtrosHttpOptions();
    return this.httpClient.get<Fornecedor>(`${this.url}/${CCODIGOLOJA}/${CMODELO}`,httpOptions);
  }

}
